@if (productDetails$ | async; as product) {
  <div class="product-details page-title">
    <div class="name">
      <h1 class="code">{{product.code}}</h1>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-3 product-image-section pdp-image-section">
      <kb-product-image-zoom></kb-product-image-zoom>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-3 product-details-section">
      <p class="productTypeNumber">{{product.typenumber}}</p>
      <p class="productName">{{product.name}}</p>
      @if (product.sapEan) {
        <p class="GtinNumber">GTIN : {{product.sapEan}}</p>
      }
      <p class="product-Statuscode"
        [ngClass]="product.salesStatusCode=='CODE30' || product.salesStatusCode=='CODE40' ||product.salesStatusCode=='code30' || product.salesStatusCode=='code40'?'green--color':''">
        @if (product.salesStatusText?.indexOf('common.')<0) {
          <span>{{product.salesStatusText}}</span>
        }
        @if (product.salesStatusText?.indexOf('common.')>-1) {
          <span>@if (product.salesStatusText) {
            <span
            >{{product.salesStatusText | cxTranslate}}</span>
          }</span>
        }
      </p>
      <p class="productMarketType">{{product.marketType}}</p>
      <div class="compare_checkbox pdp-compare">
        <app-check-box-compare [product]="product"></app-check-box-compare>
      </div>
      @if (product.replacedByProductCode && product.replaceByText) {
        <p class="productReplaceBy">
          {{product.replaceByText|cxTranslate}} <a class="replaceByTextPDP" [class.active]="product.replacedByPDPUrl"
        [href]="product.replacedByPDPUrl">{{product.replacedByProductCode}}</a></p>
      }
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-3 product-price-Section">
      @if (custIDService.fleetPrideGroup$|async) {
        <div>
          @if (product.customerPriceText) {
            <div class="row">
              <div class="col-md-7 pdp-price-label">{{product.customerPriceText | cxTranslate}}<span
              class="perPiece">{{'common.basket_page_per_pc'|cxTranslate}}</span></div>
              @if (!product.listPrice?.formattedValue ||  product.listPrice?.formattedValue.indexOf('-')  > -1) {
                <div class="col-md-5 pdp-price-val no-padding"
                  >
                  @if (product.customerPriceText) {
                    <span>{{'common.basket_page_poa'|cxTranslate}}</span>
                  }
                </div>
              }
              @if (product.listPrice?.formattedValue && product.listPrice?.formattedValue.indexOf('-')  <  0) {
                <div class="col-md-5 pdp-price-val no-padding"
                  >
                  {{product.listPrice?.formattedValue}}&nbsp;
                  <span>
                    {{product.listPrice?.currencyIso}}
                  </span>
                </div>
              }
            </div>
          }
          @if (product.netPriceText) {
            <div class="row">
              <div class="col-md-7 pdp-price-label">{{product.netPriceText | cxTranslate}}<span
              class="perPiece">{{'common.basket_page_per_pc'|cxTranslate}}</span></div>
              @if (!product.netPrice?.formattedValue|| product.netPrice?.formattedValue.indexOf('-')  >  -1) {
                <div class="col-md-5 pdp-price-val no-padding"
                  >
                  @if (product.priceOnRequestText) {
                    <span>{{'common.basket_page_poa'|cxTranslate}}</span>
                  }
                </div>
              }
              @if (product.netPrice?.formattedValue && product.netPrice?.formattedValue.indexOf('-')  <  0) {
                <div class="col-md-5 pdp-price-val no-padding"
                  >
                  {{product.netPrice?.formattedValue}}&nbsp;
                  <span>
                    {{product.netPrice?.currencyIso}}
                  </span>
                </div>
              }
            </div>
          }
          @if (product.coreDepositeText) {
            <div class="row">
              <div class="col-md-7 pdp-price-label">{{product.coreDepositeText | cxTranslate}}<span
              class="perPiece">{{'common.basket_page_per_pc'|cxTranslate}}</span></div>
              @if (!product.corePrice?.formattedValue|| product.corePrice?.formattedValue.indexOf('-')  > -1) {
                <div class="col-md-5 pdp-price-val no-padding"
                  >
                  @if (product.priceOnRequestText) {
                    <span>{{'common.basket_page_poa'|cxTranslate}}</span>
                  }
                </div>
              }
              @if (product.corePrice?.formattedValue && product.corePrice?.formattedValue.indexOf('-')  <  0) {
                <div class="col-md-5 pdp-price-val no-padding"
                  >
                  {{product.corePrice?.formattedValue}}&nbsp;
                  <span>
                    {{product.corePrice?.currencyIso}}
                  </span>
                </div>
              }
            </div>
          }
          @if (+product?.packagingSet > 0) {
            <div class="row">
              <div class="col-md-7 pdp-price-label">{{'common.pdp_page_generaltab_soldinmultipleof' |
              cxTranslate}}</div>
              <div class="col-md-5 pdp-price-val no-padding">
                {{+product?.packagingSet}}
              </div>
            </div>
          }
        </div>
      }
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-3 product-list-button-block">
      <app-kb-add-to-cart [showQuantity]="true" [isContactUs]='((product.isContactUs))'
        [isPriceAvail]='(product?.coreDepositeText?.length>0 || product?.netPriceText?.length>0|| product?.customerPriceText?.length>0)'
      [purchasable]="product.isAddToCart" [productCode]="product?.code"></app-kb-add-to-cart>
      @if (isLoggedIn && product.isCheckAvailibility) {
        <button (click)="checkAvailability(product?.code)"
        class='fs-16 check-avl-btn btn btn-secondary btn-block check-avl check-avl-btn check-available'>{{'common.check_availability_btn_text'|cxTranslate}}</button>
      }
      @if (isLoggedIn && product.isQoute) {
        <button [disabled]="product.listPrice?.formattedValue"
          (click)="createAQuote(product.code)"
        class='btn btn-primary btn-block check-avl'>{{'common.quote_create'|cxTranslate}}</button>
      }
      @if (product.isContactUs && isLoggedIn  && !product.isQoute) {
        <a
          class='btn btn-primary btn-block check-avl contact-us-btn' [href]="product?.contactUsUrl"
        target="_blank">{{'common.pdp_page_contact_us'|cxTranslate}}</a>
      }
      @if (product.isEnqury && isLoggedIn) {
<a [href]="'mailto:' + product?.contactEmail + '?subject=' + product?.code"
        class='btn btn-primary btn-block check-avl enquiry-btn'>
          {{ 'common.pdp_page_contact_enquiry' | cxTranslate }}
          <img src="/icons/mail-white.svg" alt="Enquiry" class="mail-icon" width="20" />
        </a>
      }
    </div>
  </div>
  <!-- when Product as BaseProducts carousel -->
  <app-kb-product-carousel [product]="product"></app-kb-product-carousel>
  <app-kb-product-tabs [product]="product"></app-kb-product-tabs>
}